import { PortalShell } from './portal-shell';

function Portal({ account, onAccountUpdated, onSignOut }) {
  return <PortalShell account={account} onAccountUpdated={onAccountUpdated} onSignOut={onSignOut} />;
}

export default Portal;
